import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './originExpenditureForm';
import List from './originExpenditureList';

const settings = {
    pathRegister: paths.originExpenditureRegister,
    pathList: paths.originExpenditure,
    apiPath: 'origin-expenditure',
    permissionAdmin: null,
    title: 'Tipo de despesa',
    entity: 'originExpenditure',
};

const OriginExpenditure: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const OriginExpenditureList: React.FC = () => {
    return (
        <MainContainer>
            <List />
        </MainContainer>
    );
};

export { OriginExpenditure, OriginExpenditureList };
